import React, { useEffect, useState } from "react";
import PageTitle from "../../../layouts/PageTitle";

const TestimonialsDashboard = () => {

  const [testimonials, setTestimonials] = useState([]);
  const [form, setForm] = useState({
    name: "",
    role: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  // ================= FETCH =================
  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const res = await fetch("/backend/testimonials");
      const data = await res.json();
      setTestimonials(data);
    } catch (err) {
      console.log(err);
    }
  };

  // ================= ADD =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetch("/backend/testimonials", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      setForm({ name: "", role: "", message: "" });
      fetchTestimonials();

    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    await fetch(`/backend/testimonials/${id}`, {
      method: "DELETE",
    });

    setTestimonials(testimonials.filter((item) => item.id !== id));
  };

  return (
    <>
      <PageTitle activeMenu="Testimonials" motherMenu="Dashboard" />

      <div className="row">

        {/* ================= ADD FORM ================= */}
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Testimonial</h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-md-4 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Patient Name"
                      value={form.name}
                      onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Role (Patient / Client)"
                      value={form.role}
                      onChange={(e) =>
                        setForm({ ...form, role: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <button className="btn btn-primary w-100">
                      {loading ? "Adding..." : "Add Testimonial"}
                    </button>
                  </div>

                  <div className="col-md-12">
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Write testimonial message..."
                      value={form.message}
                      onChange={(e) =>
                        setForm({ ...form, message: e.target.value })
                      }
                      required
                    ></textarea>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ================= LIST ================= */}
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">All Testimonials</h4>
            </div>

            <div className="card-body">

              {testimonials.length === 0 ? (
                <p>No testimonials found</p>
              ) : (

                <div className="row">

                  {testimonials.map((item) => (
                    <div className="col-lg-4 mb-4" key={item.id}>

                      <div className="card shadow-sm border-0 h-100">

                        <div className="card-body">

                          {/* ⭐ Stars */}
                          <div className="mb-2 text-warning">
                            ★★★★★
                          </div>

                          {/* MESSAGE */}
                          <p style={{ minHeight: "80px" }}>
                            {item.message}
                          </p>

                          {/* USER */}
                          <h5 className="mb-0">{item.name}</h5>
                          <small className="text-muted">{item.role}</small>

                        </div>

                        {/* DELETE BUTTON */}
                        <div className="card-footer text-end bg-white border-0">
                          <button
                            onClick={() => handleDelete(item.id)}
                            className="btn btn-danger btn-sm"
                          >
                            Delete
                          </button>
                        </div>

                      </div>

                    </div>
                  ))}

                </div>

              )}

            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default TestimonialsDashboard;